/* ============ Stryde motion (2026-09-30) ============
   Heavy motion utan bibliotek: kinetisk rubrik, 3D-tilt, magnetiska knappar,
   marquee med scrollskev, parallax, wipe, scrollstyrd mekanism (knae/fod/svang/sleeve/brace,
   samma diagram som i annonserna), fly-to-cart och skrapkortet med rabattkod. */
(function () {
  'use strict';
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const clamp = (x, a, b) => Math.max(a === undefined ? 0 : a, Math.min(b === undefined ? 1 : b, x));
  const ease = p => 1 - Math.pow(1 - clamp(p), 3);
  const back = p => { p = clamp(p) - 1; return p * p * (2.9 * p + 1.9) + 1; };
  const prog = (x, a, d) => clamp((x - a) / d);
  const store = {
    get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch (e) { } },
    sget(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    sset(k, v) { try { sessionStorage.setItem(k, v); } catch (e) { } }
  };

  /* ---------------- kinetisk rubrik ---------------- */
  function kinetic(el) {
    let i = 0;
    const wrapWords = (node, into) => {
      node.textContent.split(/(\s+)/).forEach(part => {
        if (!part) return;
        if (/^\s+$/.test(part)) { into.appendChild(document.createTextNode(' ')); return; }
        const w = document.createElement('span'); w.className = 'm-w';
        const inner = document.createElement('span'); inner.textContent = part; inner.style.setProperty('--i', i++);
        w.appendChild(inner); into.appendChild(w);
      });
    };
    const frag = document.createDocumentFragment();
    Array.from(el.childNodes).forEach(n => {
      if (n.nodeType === 3) wrapWords(n, frag);
      else if (n.nodeType === 1) {
        const c = n.cloneNode(false);
        Array.from(n.childNodes).forEach(k => k.nodeType === 3 ? wrapWords(k, c) : c.appendChild(k.cloneNode(true)));
        if (c.tagName === 'EM') c.insertAdjacentHTML('beforeend', '<svg class="m-scribble" viewBox="0 0 300 30" preserveAspectRatio="none"><path d="M4 20 C 60 6, 120 26, 180 14 S 270 8, 296 18"/></svg>');
        frag.appendChild(c);
      }
    });
    el.innerHTML = ''; el.appendChild(frag);
  }

  /* ---------------- hero ---------------- */
  function hero(root) {
    $$('.m-kin', root).forEach(kinetic);
    // introt startar nar hero syns (den ligger inte langre forst pa startsidan), annars spelas den upp osedd
    const go = () => { root.classList.add('is-in'); $$('.m-kin', root).forEach(k => k.classList.add('is-in')); };
    const io = new IntersectionObserver(es => { if (es[0].isIntersecting) { io.disconnect(); requestAnimationFrame(go); } }, { threshold: .15 });
    io.observe(root);
    // bilden flyter inte (anvandaren 2026-09-30): ingen 3D-tilt och ingen parallax
  }

  /* ---------------- magnetiska knappar + ripple ---------------- */
  function magnetic() {
    if (reduce || !window.matchMedia('(pointer:fine)').matches) return;
    $$('.m-hero .btn, .m-mag, .m-mech .btn').forEach(b => {
      b.classList.add('m-mag');
      b.addEventListener('pointermove', e => { const r = b.getBoundingClientRect(); b.style.transform = `translate(${(e.clientX - r.left - r.width / 2) * .25}px, ${(e.clientY - r.top - r.height / 2) * .35}px)`; });
      b.addEventListener('pointerleave', () => { b.style.transform = ''; });
    });
  }
  function ripples() {
    document.addEventListener('pointerdown', e => {
      const b = e.target.closest('.btn'); if (!b || reduce) return;
      const r = b.getBoundingClientRect(), s = Math.max(r.width, r.height), d = document.createElement('span');
      d.className = 'm-ripple'; d.style.cssText = `width:${s}px;height:${s}px;left:${e.clientX - r.left - s / 2}px;top:${e.clientY - r.top - s / 2}px`;
      b.appendChild(d); setTimeout(() => d.remove(), 700);
    });
  }

  /* ---------------- marquee: skev efter scrollhastighet ---------------- */
  function marquees() {
    const ms = $$('.m-marquee'); if (!ms.length || reduce) return;
    let last = window.scrollY, v = 0, igang = false, synliga = 0;
    const io = new IntersectionObserver(es => es.forEach(e => { synliga += e.isIntersecting ? 1 : -1; }));
    ms.forEach(m => io.observe(m));
    const tick = () => {
      const y = window.scrollY; v = v * .85 + (y - last) * .15; last = y;
      const skev = Math.abs(v) < .05 ? 0 : clamp(v * .08, -5, 5);
      ms.forEach(m => m.style.setProperty('--skew', `${skev}deg`));
      if (skev === 0) { igang = false; v = 0; return; }
      requestAnimationFrame(tick);
    };
    window.addEventListener('scroll', () => { if (!igang && synliga > 0) { igang = true; last = window.scrollY; requestAnimationFrame(tick); } }, { passive: true });
  }

  /* ---------------- reveal: wipe / rise / parallax ---------------- */
  function reveals() {
    const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -12% 0px' });
    $$('.m-wipe, .m-rise').forEach(el => io.observe(el));
    if (reduce) return;
    const par = $$('[data-m-par]');
    if (par.length) window.addEventListener('scroll', () => par.forEach(el => {
      const r = el.getBoundingClientRect(); el.style.translate = `0 ${(r.top + r.height / 2 - innerHeight / 2) * -parseFloat(el.dataset.mPar)}px`;
    }), { passive: true });
  }

  /* ================= diagrammen (samma former som i annonserna) ================= */
  const C = { hud: '#f3d6c0', kontur: '#3c4250', bla: '#0a84ff', rod: '#ff3b30', gron: '#34c759', rem: '#1c1e22', ben: '#e2e6ee' };
  function Bana() { this.p = []; }
  Bana.prototype.m = function (x, y) { this.p.push([x, y]); return this; };
  Bana.prototype.l = function (x, y) { this.p.push([x, y]); return this; };
  Bana.prototype.c = function (x1, y1, x2, y2, x, y) {
    const [x0, y0] = this.p[this.p.length - 1];
    for (let i = 1; i <= 24; i++) {
      const t = i / 24, u = 1 - t;
      this.p.push([u * u * u * x0 + 3 * u * u * t * x1 + 3 * u * t * t * x2 + t * t * t * x, u * u * u * y0 + 3 * u * u * t * y1 + 3 * u * t * t * y2 + t * t * t * y]);
    }
    return this;
  };
  Bana.prototype.langd = function () { let s = 0; for (let i = 1; i < this.p.length; i++) s += Math.hypot(this.p[i][0] - this.p[i - 1][0], this.p[i][1] - this.p[i - 1][1]); return s; };
  Bana.prototype.del = function (f) {
    if (f >= 1) return this.p;
    const L = this.langd() * clamp(f), ut = [this.p[0]]; let s = 0;
    for (let i = 1; i < this.p.length; i++) {
      const d = Math.hypot(this.p[i][0] - this.p[i - 1][0], this.p[i][1] - this.p[i - 1][1]);
      if (s + d >= L) { const k = (L - s) / d; ut.push([this.p[i - 1][0] + (this.p[i][0] - this.p[i - 1][0]) * k, this.p[i - 1][1] + (this.p[i][1] - this.p[i - 1][1]) * k]); break; }
      ut.push(this.p[i]); s += d;
    }
    return ut;
  };
  Bana.prototype.punkt = function (f) { const d = this.del(f); return d[d.length - 1]; };
  function linje(ctx, pts, farg, bredd, alfa, glod) {
    if (pts.length < 2) return;
    ctx.save(); ctx.globalAlpha = alfa === undefined ? 1 : alfa; ctx.strokeStyle = farg; ctx.lineWidth = bredd; ctx.lineCap = 'round'; ctx.lineJoin = 'round';
    ctx.beginPath(); ctx.moveTo(pts[0][0], pts[0][1]); for (let i = 1; i < pts.length; i++) ctx.lineTo(pts[i][0], pts[i][1]); ctx.stroke(); ctx.restore();
  }
  function fyll(ctx, pts, farg, skugga) {
    ctx.save(); ctx.fillStyle = farg; if (skugga) { ctx.save(); ctx.translate(0, 14); ctx.fillStyle = 'rgba(20,30,50,.06)'; ctx.beginPath(); ctx.moveTo(pts[0][0], pts[0][1]); for (let i = 1; i < pts.length; i++) ctx.lineTo(pts[i][0], pts[i][1]); ctx.closePath(); ctx.fill(); ctx.restore(); }
    ctx.beginPath(); ctx.moveTo(pts[0][0], pts[0][1]); for (let i = 1; i < pts.length; i++) ctx.lineTo(pts[i][0], pts[i][1]); ctx.closePath(); ctx.fill(); ctx.restore();
  }
  const blandning = s => `rgb(${Math.round(10 + 245 * s)},${Math.round(132 - 90 * s)},${Math.round(255 - 210 * s)})`;
  function pil(ctx, x, y, langd, vinkel, p, farg, bredd) {
    if (p <= 0) return;
    const r = vinkel * Math.PI / 180, l = langd * ease(p), x1 = x + Math.cos(r) * l, y1 = y + Math.sin(r) * l, n = [Math.cos(r), Math.sin(r)], v = [-n[1], n[0]];
    ctx.save(); ctx.strokeStyle = ctx.fillStyle = farg; ctx.lineWidth = bredd; ctx.beginPath(); ctx.moveTo(x, y); ctx.lineTo(x1, y1); ctx.stroke();
    ctx.beginPath(); ctx.moveTo(x1 + n[0] * bredd * 1.9, y1 + n[1] * bredd * 1.9); ctx.lineTo(x1 + v[0] * bredd * 1.5, y1 + v[1] * bredd * 1.5); ctx.lineTo(x1 - v[0] * bredd * 1.5, y1 - v[1] * bredd * 1.5); ctx.closePath(); ctx.fill(); ctx.restore();
  }
  function bock(ctx, x, y, p, r) {
    if (p <= 0) return;
    const s = back(p); ctx.save(); ctx.translate(x, y); ctx.scale(s, s);
    ctx.fillStyle = C.gron; ctx.beginPath(); ctx.arc(0, 0, r, 0, 7); ctx.fill();
    const b = new Bana().m(-r * .45, 0).l(-r * .12, r * .38).l(r * .5, -r * .36);
    linje(ctx, b.del(prog(p, .15, .45)), '#fff', r * .22); ctx.restore();
  }

  // ---- knat (knae_grafik.py) ----
  const PIVOT = [575, 965];
  const rot = (x, y, boj, k) => { const a = 42 * boj * (k || 1) * Math.PI / 180, dx = x - PIVOT[0], dy = y - PIVOT[1]; return [PIVOT[0] + dx * Math.cos(a) - dy * Math.sin(a), PIVOT[1] + dx * Math.sin(a) + dy * Math.cos(a)]; };
  function knaBana(b) {
    const r = (x, y) => rot(x, y, b), h = (x, y) => rot(x, y, b, .5);
    return new Bana().m(420, 180).c(520, 330, 600, 560, 640, 760).c(660, 820, 690, 850, 688, 905)
      .c(686, 950, ...h(650, 975), ...r(640, 1000)).c(...r(628, 1150), ...r(620, 1380), ...r(612, 1560))
      .c(...r(610, 1640), ...r(612, 1700), ...r(640, 1760)).l(...r(470, 1760)).c(...r(478, 1690), ...r(470, 1620), ...r(462, 1540))
      .c(...r(430, 1330), ...r(380, 1180), ...r(420, 1060)).c(...h(440, 1000), 455, 960, 450, 900).c(440, 700, 330, 420, 250, 180);
  }
  function senaBana(b) { const [x1, y1] = rot(622, 1085, b); return new Bana().m(652, 928).c(668, 970, x1 + 22, y1 - 60, x1, y1); }
  function ritaKna(ctx, s, t) {
    const ben = knaBana(s.boj);
    if (s.rita >= 1) fyll(ctx, ben.p, C.hud, true);
    linje(ctx, ben.del(s.rita), C.kontur, 10);
    if (s.rita >= 1) { ctx.save(); ctx.fillStyle = '#ece8de'; ctx.strokeStyle = C.kontur; ctx.lineWidth = 5; ctx.beginPath(); ctx.ellipse(644, 877, 32, 57, 0, 0, 7); ctx.fill(); ctx.stroke(); ctx.restore(); }
    const sena = senaBana(s.boj), d = sena.del(s.sena), puls = s.stress > .5 ? .5 + .5 * Math.sin(t * 9) : 0;
    if (s.sena > 0) {
      linje(ctx, d, s.stress > .4 ? C.rod : C.bla, 54, s.stress > .4 ? (.3 + .4 * puls) * s.stress : .25, 30);
      linje(ctx, d, blandning(s.stress), 24);
    }
    if (s.rem > 0) {
      const dx = (1 - back(s.rem)) * 520, y0 = 975, fram = 656;
      ctx.save(); ctx.translate(dx, 0);
      linje(ctx, new Bana().m(438, y0 + 30).c(500, y0 + 6, 600, y0 - 8, fram, y0 - 2).p, C.rem, 34);
      ctx.fillStyle = C.rem; ctx.beginPath(); ctx.roundRect(fram - 42 - 12 * s.tryck, y0 - 34, 66, 68, 22); ctx.fill(); ctx.restore();
      for (let k = 0; k < 3; k++) pil(ctx, 880 - 70 * ease(s.tryck), y0 - 70 + 70 * k, 130, 180, clamp(s.tryck * 1.4 - k * .2), C.gron, 14);
    }
  }
  // ---- foten med strumpans remmar (demo_motion.py) ----
  function fotSleeve() {
    return new Bana().m(345, 380).l(330, 600).c(300, 760, 215, 860, 238, 975).c(250, 1045, 300, 1075, 360, 1072).c(470, 1068, 520, 1010, 640, 1018)
      .c(740, 1024, 800, 1072, 880, 1075).c(935, 1077, 955, 1040, 925, 1012).c(880, 975, 760, 930, 640, 850).c(560, 795, 520, 700, 505, 600).l(515, 380);
  }
  function ritaSleeve(ctx, s, t) {
    const f = fotSleeve();
    if (s.rita >= 1) fyll(ctx, f.p, C.hud, true);
    linje(ctx, f.del(s.rita), C.kontur, 10);
    const y = 995 + 45 * s.last, band = new Bana().m(318, 1048).c(450, y, 640, y - 10 + 10 * s.last, 800, 1052);
    const puls = s.stress > .5 ? .5 + .5 * Math.sin(t * 9) : 0;
    if (s.band > 0) { linje(ctx, band.del(s.band), s.stress > .4 ? C.rod : C.bla, 46, s.stress > .4 ? .35 + .35 * puls : .25, 24); linje(ctx, band.del(s.band), blandning(s.stress), 22); }
    const remmar = [new Bana().m(430, 1070).c(470, 930, 560, 820, 640, 790), new Bana().m(560, 1040).c(560, 920, 480, 800, 420, 720)];
    remmar.forEach((r, i) => { const p = clamp(s.remmar * 1.4 - i * .4); if (p > 0) { linje(ctx, r.del(p), C.gron, 48, .35, 14); linje(ctx, r.del(p), C.gron, 26); } });
    if (s.vikt > 0) { const ay = 170 + 60 * (1 - back(s.vikt)); pil(ctx, 430, ay - 60, 150, 90, s.vikt, '#141418', 26); }
    if (s.ringar > 0) for (let k = 0; k < 3; k++) { const q = ((t * .9) + k / 3) % 1; ctx.save(); ctx.globalAlpha = (1 - q) * .6 * s.ringar; ctx.strokeStyle = C.bla; ctx.lineWidth = 8; ctx.beginPath(); ctx.arc(600, 960, 140 + 240 * q, 0, 7); ctx.stroke(); ctx.restore(); }
  }
  // ---- fotvalvet och Arch Pro (fot_grafik.py) ----
  const valvY = pl => 990 + 70 * pl;
  function fotValv(pl) {
    const v = valvY(pl);
    return new Bana().m(330, 300).l(318, 760).c(300, 860, 250, 930, 262, 1010).c(270, 1060, 310, 1085, 370, 1082).c(450, 1080, 470, v + 10, 560, v)
      .c(650, v - 5, 700, 1070 - 20 * (1 - pl), 790, 1080).c(860, 1086, 930, 1088, 960, 1070).c(985, 1052, 975, 1022, 945, 1012)
      .c(880, 990, 790, 960, 700, 900).c(610, 840, 540, 760, 520, 660).l(510, 300);
  }
  function ritaValv(ctx, s, t) {
    const f = fotValv(s.platt);
    if (s.rita >= 1) fyll(ctx, f.p, C.hud, true);
    linje(ctx, f.del(s.rita), C.kontur, 10);
    const v = valvY(s.platt), fas = new Bana().m(345, 1058).c(450, 1055, 470, v + 22, 560, v + 18).c(660, v + 14, 720, 1062, 820, 1062);
    const puls = s.stress > .5 ? .5 + .5 * Math.sin(t * 9) : 0;
    if (s.fascia > 0) { linje(ctx, fas.del(s.fascia), s.stress > .4 ? C.rod : C.bla, 50, s.stress > .4 ? .3 + .4 * puls : .25, 22); linje(ctx, fas.del(s.fascia), blandning(s.stress), 22); }
    if (s.sula > 0) {
      const dy = (1 - back(s.sula)) * 420; ctx.save(); ctx.translate(0, dy);
      const bas = new Bana().m(262, 1040).c(262, 1100, 300, 1114, 370, 1112).l(900, 1106).c(935, 1104, 945, 1092, 932, 1084).l(800, 1086)
        .c(700, 1084, 650, v + 18, 560, v + 26).c(470, v + 30, 450, 1088, 372, 1090).c(320, 1090, 290, 1070, 282, 1040);
      fyll(ctx, bas.p, '#f6f6f4');
      const skal = new Bana().m(268, 1045).c(270, 1098, 305, 1108, 372, 1106).c(470, 1102, 560, v + 50, 680, 1080).l(700, 1090)
        .c(640, 1084, 600, v + 24, 560, v + 28).c(470, v + 32, 450, 1090, 372, 1092).c(318, 1092, 290, 1072, 282, 1045);
      fyll(ctx, skal.p, '#d62228');
      linje(ctx, new Bana().m(284, 1042).c(300, 1078, 330, 1088, 372, 1088).c(450, 1086, 470, v + 30, 560, v + 24).c(650, v + 16, 700, 1082, 800, 1084).l(930, 1084).p, '#18181c', 9);
      ctx.fillStyle = '#ffd60a'; ctx.beginPath(); ctx.ellipse(348, 1095, 30, 9, 0, 0, 7); ctx.fill();
      ctx.restore();
    }
    if (s.pilar > 0) { pil(ctx, 560, v - 330, 170, 90, s.pilar, '#141418', 24); pil(ctx, 470, 1150, 110, 180, s.pilar, C.rod, 16); pil(ctx, 650, 1150, 110, 0, s.pilar, C.rod, 16); }
  }

  // ---- knat framifran (kna_fram.py): Knee Sleeve och Knee Brace Pro ----
  const FX = 540, FY = 930;
  const fKant = (y, sv) => y <= 800 ? 165 - (y - 200) / 600 * 40
    : y <= 1060 ? 125 + (14 + (sv || 0) * 26) * Math.sin((y - 800) / 260 * Math.PI)
    : 118 - (y - 1060) / 640 * 48 + 10 * Math.sin(clamp((y - 1060) / 300) * Math.PI);
  const fRot = (x, y, v) => { if (y <= FY || !v) return [x, y]; const a = v * Math.PI / 180, dx = x - FX, dy = y - FY; return [FX + dx * Math.cos(a) - dy * Math.sin(a), FY + dx * Math.sin(a) + dy * Math.cos(a)]; };
  function fBen(v, sv, y0, y1, bred) {
    const L = [], R = [];
    for (let y = y0; y <= y1; y += 20) { L.push(fRot(FX - fKant(y, sv) * bred, y, v)); R.push(fRot(FX + fKant(y, sv) * bred, y, v)); }
    const b = new Bana(); b.p = L.concat(R.reverse()); return b;
  }
  const sluten = p => p.concat([p[0]]);
  function rander(ctx, pts, farg, y0, y1, steg, alfa) {
    ctx.save(); ctx.beginPath(); ctx.moveTo(pts[0][0], pts[0][1]); for (const q of pts) ctx.lineTo(q[0], q[1]); ctx.closePath(); ctx.clip();
    ctx.globalAlpha = alfa; ctx.strokeStyle = farg; ctx.lineWidth = 4; ctx.beginPath();
    for (let y = y0; y < y1; y += steg) { ctx.moveTo(FX - 260, y); ctx.lineTo(FX + 260, y); }
    ctx.stroke(); ctx.restore();
  }
  function ritaFram(ctx, s, t) {
    const v = (s.svaj || 0) * 9 * Math.sin(t * 4.2), sv = s.svull || 0, ben = fBen(v, sv, 200, 1700, 1);
    if (s.rita >= 1) fyll(ctx, ben.p, C.hud, true);
    if (s.stress > 0) {
      const pu = .6 + .4 * Math.sin(t * 7);
      ctx.save(); ctx.fillStyle = C.rod; ctx.globalAlpha = .2 * s.stress * pu; ctx.beginPath(); ctx.ellipse(FX, FY, 160, 56, 0, 0, 7); ctx.fill();
      ctx.globalAlpha = .55 * s.stress; ctx.beginPath(); ctx.ellipse(FX, FY, 95, 14, 0, 0, 7); ctx.fill(); ctx.restore();
    }
    // ett vanligt knaskydd som hasar ner
    if (s.vanligt > 0) {
      const g = s.glid || 0, dy = (1 - s.vanligt) * 500 + g * 330, y0 = Math.round((760 + dy) / 20) * 20, y1 = y0 + 360, h = fBen(v, sv, y0, y1, 1.05 + .03 * g);
      fyll(ctx, h.p, '#aaaab0'); rander(ctx, h.p, '#8c8c94', y0, y1, 22, .5); linje(ctx, sluten(h.p), '#6e6e76', 5);
      if (g > .2) for (let k = 0; k < 3; k++) { const y = y0 + 8 + k * 12; linje(ctx, [fRot(FX - fKant(y, sv) * 1.08, y, v), fRot(FX + fKant(y, sv) * 1.08, y, v)], '#78787f', 7, g); }
    }
    // Knee Sleeve: kompression runt hela knat och band i kryss
    if (s.ks > 0) {
      const dy = (1 - s.ks) * 620, y0 = Math.round((690 + dy) / 20) * 20, y1 = y0 + 480, h = fBen(v, sv, y0, y1, 1.07);
      fyll(ctx, h.p, '#34363c', true); rander(ctx, h.p, '#62666e', y0, y1, 24, .45);
      if (s.ks > .8) {
        ctx.save(); ctx.strokeStyle = '#62666e'; ctx.globalAlpha = .9; ctx.lineWidth = 12; ctx.beginPath(); ctx.ellipse(FX, 890 + dy, 70, 70, 0, 0, 7); ctx.stroke();
        ctx.globalAlpha = .5; ctx.lineWidth = 6; ctx.beginPath(); ctx.ellipse(FX, 892 + dy, 95, 92, 0, 0, 7); ctx.stroke(); ctx.restore();
      }
      linje(ctx, sluten(h.p), '#1e1e22', 6);
      if (s.tryck > 0) {
        const pu = .5 + .5 * Math.sin(t * 5);
        [800, 900, 1000, 1100].forEach((y, k) => [-1, 1].forEach(sd => pil(ctx, FX + sd * (fKant(y, sv) * 1.07 + 95 - 18 * pu), y, 70, sd < 0 ? 0 : 180, clamp(s.tryck * 1.6 - k * .15), C.bla, 14)));
        linje(ctx, sluten(h.p), C.bla, 26, .2 * s.tryck * (.6 + .4 * pu));
      }
      if (s.kryss > 0) {
        [[[-150, 860], [150, 1110]], [[150, 860], [-150, 1110]]].forEach(([a, b], k) => {
          const q = clamp(s.kryss * 2 - k * .7); if (q <= 0) return;
          const A = fRot(FX + a[0], a[1], v), B = fRot(FX + b[0], b[1], v), P = [A, [A[0] + (B[0] - A[0]) * q, A[1] + (B[1] - A[1]) * q]];
          linje(ctx, P, '#000', 74, .22); linje(ctx, P, '#121214', 62); linje(ctx, P, '#46464c', 4, .8);
        });
        if (s.kryss >= .95) { ctx.save(); ctx.fillStyle = '#5a5a60'; [-1, 1].forEach(sd => [860, 1110].forEach(y => { const [x, yy] = fRot(FX + sd * 150, y, v); ctx.fillRect(x - 30, yy - 32, 60, 64); })); ctx.restore(); }
      }
    }
    // Knee Brace Pro: gelring, sidostod och vridhjul med snoren
    if (s.kb > 0) {
      const dy = (1 - s.kb) * 620, fit = 1.08 - .03 * (s.snoren || 0), y0 = Math.round((680 + dy) / 20) * 20, y1 = y0 + 500, h = fBen(v, sv, y0, y1, fit);
      fyll(ctx, h.p, '#f4f5f7', true); rander(ctx, h.p, '#c4c8d0', y0, y1, 30, .5); linje(ctx, sluten(h.p), '#aaaeb6', 5);
      if (s.kb >= .9) {
        if (s.sido > 0) [-1, 1].forEach(sd => {
          const p0 = [FX + sd * fKant(760) * fit * .93, 760], c = [FX + sd * (fKant(FY, sv) * fit * .97 + 6), FY], e = fRot(FX + sd * fKant(1110) * fit * .9, 1110, v);
          const b = new Bana().m(p0[0], p0[1]).c(p0[0] + 2 / 3 * (c[0] - p0[0]), p0[1] + 2 / 3 * (c[1] - p0[1]), e[0] + 2 / 3 * (c[0] - e[0]), e[1] + 2 / 3 * (c[1] - e[1]), e[0], e[1]);
          const d = b.del(s.sido); linje(ctx, d, '#969ca8', 22); linje(ctx, d, '#d2d6de', 8);
          if (s.sidoTar > 0) { linje(ctx, b.p, C.gron, 40, .3 * s.sidoTar); linje(ctx, b.p, C.gron, 12, s.sidoTar); }
        });
        if (s.gel > 0) {
          const ring = new Bana(); for (let i = 0; i <= 64; i++) { const a = -Math.PI / 2 + i / 64 * Math.PI * 2; ring.p.push([FX + 78 * Math.cos(a), 887 + 75 * Math.sin(a)]); }
          const d = ring.del(s.gel); linje(ctx, d, '#78d6cd', 46, .4); linje(ctx, d, '#78d6cd', 30, .95); linje(ctx, d, '#fff', 6, .5);
          if (s.gelPuls > 0) { const q = (t * 1.2) % 1; ctx.save(); ctx.globalAlpha = s.gelPuls * (1 - q) * .8; ctx.strokeStyle = '#78d6cd'; ctx.lineWidth = 6; ctx.beginPath(); ctx.ellipse(FX, 887, 78 + 60 * q, 75 + 60 * q, 0, 0, 7); ctx.stroke(); ctx.restore(); }
        }
        const hx = FX + fKant(FY, sv) * fit - 6, hy = FY + 20;
        if (s.hjul > 0 && s.snorenSyns > 0) [[780, 860], [1080, 1000]].forEach(([ya, yb]) => {
          const d = new Bana().m(hx, hy).c(FX + 60, ya, FX - 60, ya, FX - fKant(ya) * fit * .95, yb).del(s.snorenSyns);
          linje(ctx, d, '#50566a', 5, .9); if (s.snoren > 0) linje(ctx, d, '#ef6c1a', 7, .9 * s.snoren);
        });
        if (s.hjul > 0) {
          const r = 46 * back(clamp(s.hjul * 1.2)), a0 = (s.hjulV || 0) * Math.PI / 180;
          ctx.save(); ctx.fillStyle = 'rgba(0,0,0,.18)'; ctx.beginPath(); ctx.arc(hx, hy + 6, r + 6, 0, 7); ctx.fill();
          ctx.fillStyle = '#eceef2'; ctx.beginPath(); ctx.arc(hx, hy, r, 0, 7); ctx.fill(); ctx.strokeStyle = '#8c929e'; ctx.lineWidth = 6; ctx.stroke();
          ctx.strokeStyle = '#969ca8'; ctx.lineWidth = 5; ctx.beginPath();
          for (let k = 0; k < 12; k++) { const a = a0 + k * Math.PI / 6; ctx.moveTo(hx + Math.cos(a) * r * .55, hy + Math.sin(a) * r * .55); ctx.lineTo(hx + Math.cos(a) * r * .88, hy + Math.sin(a) * r * .88); }
          ctx.stroke(); ctx.fillStyle = '#c8ccd4'; ctx.beginPath(); ctx.arc(hx, hy, r * .3, 0, 7); ctx.fill(); ctx.restore();
        }
      }
    }
    linje(ctx, s.rita >= 1 ? sluten(ben.p) : ben.del(s.rita), C.kontur, 10);
    if (s.rita >= 1 && (s.ks || 0) < .9 && (s.kb || 0) < .9) { ctx.save(); ctx.fillStyle = '#ecc9b4'; ctx.strokeStyle = C.kontur; ctx.globalAlpha = .9; ctx.lineWidth = 5; ctx.beginPath(); ctx.ellipse(FX, 888, 58, 62, 0, 0, 7); ctx.fill(); ctx.stroke(); ctx.restore(); }
    if ((s.svaj || 0) > .05) { const d = Math.sin(t * 4.2); pil(ctx, FX + (d > 0 ? 210 : -210), FY + 150, 70, d > 0 ? 0 : 180, s.svaj * Math.abs(d), C.rod, 12); }
  }

  const TYPER = {
    knae: {
      vy: [600, 960, 820, 1020], rita: ritaKna,
      tillstand(p, t) {
        const s2 = prog(p, .25, .25), s3 = prog(p, .5, .25), s4 = prog(p, .75, .25), step = (a, n, per) => (a > 0 && a < 1) ? Math.abs(Math.sin(a * n * Math.PI)) : 0;
        return { rita: ease(prog(p, 0, .12)), sena: ease(prog(p, .06, .12)), boj: .8 * step(s2, 3) + .3 * step(s4, 2),
          stress: clamp(prog(p, .1, .1) * .6 + s2 * .6) * (1 - .85 * ease(prog(p, .78, .1))), rem: ease(prog(p, .5, .1)), tryck: ease(prog(p, .58, .1)), bock: prog(p, .8, .08) };
      }, bockXY: [900, 700]
    },
    fod: {
      vy: [585, 760, 820, 820], rita: ritaSleeve,
      tillstand(p) {
        const w = prog(p, .25, .2);
        return { rita: ease(prog(p, 0, .12)), band: ease(prog(p, .08, .12)), vikt: ease(w), last: ease(w) * (1 - .75 * ease(prog(p, .55, .15))),
          stress: ease(w) * (1 - .8 * ease(prog(p, .55, .15))), remmar: ease(prog(p, .5, .15)), ringar: prog(p, .78, .1), bock: prog(p, .8, .08) };
      }, bockXY: [880, 520]
    },
    sleeve: {
      vy: [540, 960, 760, 940], rita: ritaFram,
      tillstand(p) {
        return { rita: ease(prog(p, 0, .12)), svaj: clamp(prog(p, .08, .1)) * (1 - ease(prog(p, .6, .12))), stress: clamp(prog(p, .08, .1)) * (1 - .9 * ease(prog(p, .62, .12))),
          vanligt: ease(prog(p, .22, .1)) * (1 - ease(prog(p, .48, .08))), glid: ease(prog(p, .32, .14)), ks: ease(prog(p, .5, .1)), tryck: ease(prog(p, .58, .12)),
          kryss: ease(prog(p, .74, .12)), bock: prog(p, .86, .08) };
      }
    },
    brace: {
      vy: [560, 960, 760, 940], rita: ritaFram,
      tillstand(p) {
        return { rita: ease(prog(p, 0, .12)), svaj: clamp(prog(p, .06, .1)) * (1 - ease(prog(p, .56, .1))), stress: clamp(prog(p, .06, .1)) * (1 - .9 * ease(prog(p, .56, .12))),
          kb: ease(prog(p, .25, .12)), gel: ease(prog(p, .34, .12)), gelPuls: prog(p, .4, .05) * (1 - prog(p, .5, .05)),
          sido: ease(prog(p, .5, .1)), sidoTar: prog(p, .55, .06) * (1 - prog(p, .7, .06)),
          hjul: ease(prog(p, .74, .1)), snorenSyns: ease(prog(p, .78, .08)), snoren: ease(prog(p, .82, .1)), hjulV: prog(p, .8, .15) * 270, bock: prog(p, .9, .06) };
      }
    },
    svang: {
      vy: [620, 820, 820, 820], rita: ritaValv,
      tillstand(p) {
        const ned = ease(prog(p, .27, .18)), upp = ease(prog(p, .55, .15));
        return { rita: ease(prog(p, 0, .12)), fascia: ease(prog(p, .08, .12)), platt: ned * (1 - upp), stress: .15 + .8 * ned * (1 - upp), pilar: ned * (1 - upp),
          sula: ease(prog(p, .5, .12)), gel: prog(p, .76, .1), bock: prog(p, .8, .08) };
      }, bockXY: [880, 560]
    }
  };

  function mekanism(root) {
    const typ = TYPER[root.dataset.typ] || TYPER.knae, cv = $('canvas', root), ctx = cv.getContext('2d');
    const steg = $$('.m-step', root), barer = $$('.m-mech__bar i b', root);
    let p = 0, synlig = false, dpr = Math.min(1.5, window.devicePixelRatio || 1);
    const storlek = () => { const r = cv.getBoundingClientRect(); cv.width = r.width * dpr; cv.height = r.height * dpr; };
    storlek(); window.addEventListener('resize', storlek);
    let loop = null, lv = null, senast = 0, forst = 0;
    new IntersectionObserver(es => {
      synlig = es[0].isIntersecting;
      if (synlig && !forst) forst = performance.now();
      if (synlig && !loop) loop = requestAnimationFrame(rita);
    }).observe(root);
    const las = () => {
      const r = root.getBoundingClientRect(), h = root.offsetHeight - innerHeight;
      p = reduce ? 1 : clamp(-r.top / Math.max(1, h));
      const i = Math.min(steg.length - 1, Math.floor(p * steg.length * .999));
      steg.forEach((s, k) => s.classList.toggle('is-on', k === i));
      barer.forEach((b, k) => b.style.setProperty('--p', clamp(p * barer.length - k)));
    };
    window.addEventListener('scroll', () => { if (synlig && !lv) lv = requestAnimationFrame(() => { lv = null; las(); }); }, { passive: true }); las();
    const rita = ts => {
      if (synlig && ts - senast >= 30) {
        senast = ts;
        const t = ts / 1000, [cx, cy, bw, bh] = typ.vy, W = cv.width, H = cv.height, k = Math.min(W / bw, H / bh) * .92;
        ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.clearRect(0, 0, W, H);
        ctx.setTransform(k, 0, 0, k, W / 2 - cx * k, H / 2 - cy * k);
        const s = typ.tillstand(p, t);
        // konturen och senan/remmen ritas upp direkt nar rutan syns, sa den aldrig star tom; stegen foljer scrollen
        const intro = (ts - forst) / 900;
        s.rita = Math.max(s.rita, ease(intro));
        for (const k of ['sena', 'band', 'fascia']) if (k in s) s[k] = Math.max(s[k], ease(intro - .45));
        typ.rita(ctx, s, t);
        ctx.setTransform(1, 0, 0, 1, 0, 0); bock(ctx, W * .82, H * .16, s.bock, Math.min(W, H) * .07);
      }
      loop = synlig ? requestAnimationFrame(rita) : null;
    };
  }

  /* ---------------- fly-to-cart ---------------- */
  function flyToCart() {
    document.addEventListener('click', e => {
      const b = e.target.closest('[data-add-btn], [data-sticky-add]'); if (!b || b.disabled || reduce) return;
      const src = $('.gallery__main img.is-active') || $('.gallery__main img') || $('.sticky-add img, [data-sticky-add] img'); const mal = $('header [data-open-drawer="#CartDrawer"]') || $('header a[href$="/cart"]');
      if (!src || !mal) return;
      const a = src.getBoundingClientRect(), z = mal.getBoundingClientRect(), f = src.cloneNode();
      f.className = 'm-fly'; f.removeAttribute('srcset'); f.style.cssText += `left:${a.left}px;top:${a.top}px;width:${a.width}px;height:${a.height}px`;
      document.body.appendChild(f);
      f.animate([{ transform: 'none', opacity: 1 }, { transform: `translate(${(z.left - a.left) * .5}px, ${(z.top - a.top) * .5 - 120}px) scale(.45) rotate(-8deg)`, opacity: 1, offset: .55 },
        { transform: `translate(${z.left - a.left + z.width / 2 - a.width * .05}px, ${z.top - a.top + z.height / 2 - a.height * .05}px) scale(.08) rotate(12deg)`, opacity: .6 }],
        { duration: 900, easing: 'cubic-bezier(.5,0,.2,1)' }).onfinish = () => { f.remove(); const c = mal; c.classList.remove('m-cart-bump'); void c.offsetWidth; c.classList.add('m-cart-bump'); };
    }, true);
  }

  /* ---------------- konfetti ---------------- */
  function konfetti() {
    if (reduce) return;
    const cv = document.createElement('canvas'); cv.className = 'm-confetti'; document.body.appendChild(cv);
    const ctx = cv.getContext('2d'), W = cv.width = innerWidth, H = cv.height = innerHeight;
    const acc = getComputedStyle(document.documentElement).getPropertyValue('--accent').trim() || '#e8742a';
    const farger = [acc, '#ffd60a', '#ffffff', '#141418', '#34c759'];
    const bitar = Array.from({ length: 160 }, () => ({ x: W / 2, y: H * .45, vx: (Math.random() - .5) * 18, vy: -Math.random() * 18 - 6, r: Math.random() * 6 + 4, a: Math.random() * 6, va: (Math.random() - .5) * .4, f: farger[Math.floor(Math.random() * farger.length)] }));
    const t0 = performance.now();
    const tick = t => {
      ctx.clearRect(0, 0, W, H);
      bitar.forEach(b => { b.vy += .45; b.vx *= .99; b.x += b.vx; b.y += b.vy; b.a += b.va; ctx.save(); ctx.translate(b.x, b.y); ctx.rotate(b.a); ctx.fillStyle = b.f; ctx.fillRect(-b.r, -b.r / 2, b.r * 2, b.r); ctx.restore(); });
      if (t - t0 < 2800) requestAnimationFrame(tick); else cv.remove();
    };
    requestAnimationFrame(tick);
  }

  /* ---------------- skrapkortet ----------------
     Flode: 1) skrapa manuellt fram "10 %", 2) e-post + samtycke laser upp koden, 3) koden visas och
     laggs pa. Status i localStorage: skrabet (skrapat, ingen e-post), vunnen (koden upplast), stangd.
     Oppnas aldrig av sig sjalv om kunden redan har nagot i kurven (hon ar mitt i ett kop). */
  function skrapkort(root) {
    const kod = root.dataset.code, KEY = 'stryde_skrab', status = store.get(KEY) || '';
    const tKod = (root.dataset.tKod || 'Din kode:') + ' ', tKopierad = root.dataset.tKopierad || 'Kopieret';
    const tab = $('.m-giftab', root), modal = $('.m-scratch', root), form = $('form', root), foil = $('.m-foil', root), cv = $('canvas', foil);
    const rubrik = $('[data-rubrik]', root), text = $('[data-text]', root), las = $('.m-scratch__las', root), kodruta = $('.m-scratch__kod', root), nej = $('[data-nej]', root);
    if (/^\/(cart|checkout)/.test(location.pathname)) return;
    let visad = false, startad = false;
    const iKurven = () => { const c = $('[data-cart-count]'); return c && parseInt(c.textContent, 10) > 0; };
    // Stryde.se visar Shopifys cookiebanner overst (z-index 2 000 000) och den tackte skrapkortet helt.
    // Automatisk oppning vantar darfor tills kunden svarat pa bannern, och kommer 1,5 s efter.
    const cookieSynlig = () => { const b = document.getElementById('shopify-pc__banner'); return !!b && b.offsetHeight > 0 && getComputedStyle(b).display !== 'none'; };
    let vantar = false;
    const oppna = auto => {
      if (modal.classList.contains('is-open') || (auto && iKurven())) return;
      if (auto && cookieSynlig()) {
        if (vantar) return;
        vantar = true;
        const iv = setInterval(() => { if (!cookieSynlig()) { clearInterval(iv); vantar = false; setTimeout(() => !visad && oppna(true), 1500); } }, 400);
        return;
      }
      modal.classList.add('is-open'); visad = true; store.sset(KEY + '_s', '1'); tab.classList.remove('is-on');
      if (!startad) { startad = true; setTimeout(starta, 60); }
    };
    const stang = () => { modal.classList.remove('is-open'); if (!store.get(KEY)) store.set(KEY, 'stangd:' + Date.now()); tab.classList.add('is-on'); };
    $$('[data-close]', root).forEach(b => b.addEventListener('click', stang));
    modal.addEventListener('click', e => { if (e.target === modal) stang(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && modal.classList.contains('is-open')) stang(); });
    const visaKod = () => {
      rubrik.textContent = root.dataset.hCode; text.hidden = true; las.hidden = true; kodruta.hidden = false; nej.hidden = true;
      foil.classList.add('is-won'); modal.classList.add('is-won'); tab.querySelector('span').textContent = tKod + kod;
    };
    const visaLas = () => {
      rubrik.textContent = root.dataset.hWon; text.textContent = root.dataset.tWon; las.hidden = false; foil.classList.add('is-won');
      const f = $('[type=email]', las); if (f && matchMedia('(pointer:fine)').matches) f.focus();
    };
    tab.addEventListener('click', () => {
      if ((store.get(KEY) || '').startsWith('vunnen')) { navigator.clipboard && navigator.clipboard.writeText(kod); tab.querySelector('span').textContent = tKopierad + ': ' + kod; return; }
      oppna(false);
    });
    // tidigare besok: skrapat men inte last upp -> folien ar redan borta, formularet visas direkt
    if (status.startsWith('skrabet')) { startad = true; cv.style.display = 'none'; visaLas(); }
    if (status.startsWith('vunnen')) { startad = true; cv.style.display = 'none'; visaKod(); tab.classList.add('is-on'); return; }
    const gammal = /^(stangd|skrabet):/.test(status) && Date.now() - parseInt(status.split(':')[1], 10) < 7 * 864e5;
    if (gammal || store.sget(KEY + '_s')) { tab.classList.add('is-on'); }
    else {
      const delay = parseInt(root.dataset.delay || '20', 10) * 1000, djup = parseFloat(root.dataset.scroll || '0.5');
      const t0 = Date.now();
      setTimeout(() => !visad && oppna(true), delay);
      window.addEventListener('scroll', () => { if (!visad && Date.now() - t0 > 6000 && scrollY / (document.body.scrollHeight - innerHeight) > djup) oppna(true); }, { passive: true });
      document.addEventListener('mouseout', e => { if (!visad && !e.relatedTarget && e.clientY < 12 && Date.now() - t0 > 5000) oppna(true); });
    }

    // e-post och samtycke -> Shopify-kund med nyhetsbrev (samma som sidfotens formular)
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const epost = form.querySelector('[type=email]').value.trim(), ok = form.consent.checked, fel = $('.m-scratch__err', root);
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(epost)) { fel.textContent = root.dataset.errEmail; return; }
      if (!ok) { fel.textContent = root.dataset.errConsent; return; }
      fel.textContent = '';
      const knapp = form.querySelector('[type=submit]'); knapp.disabled = true;
      const fd = new FormData(form); fd.set('contact[email]', epost); fd.set('contact[tags]', 'newsletter,skrabekort');
      try { await fetch((window.Stryde && Stryde.routes.root || '/') + 'contact', { method: 'POST', body: fd, credentials: 'same-origin' }); } catch (x) { }
      /* koden laggs till bland varukorgens koder (GRATISEBOK, NIVA2 ligger kvar); /discount/ bara for tom varukorg (2026-10-02) */
      (async () => { const rot = (window.Stryde && Stryde.routes.root) || '/'; try { const c = await (await fetch(rot + 'cart.js')).json(); if (!c.item_count) { await fetch(rot + 'discount/' + encodeURIComponent(kod), { credentials: 'same-origin' }); return; } const k = (c.discount_codes || []).map(x => x.code); if (k.indexOf(kod) < 0) k.push(kod); await fetch(rot + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: k.join(',') }) }); } catch (x) { } })();
      store.set(KEY, 'vunnen:' + Date.now()); visaKod(); konfetti();
    });

    function starta() {
      const ctx = cv.getContext('2d'), W = cv.offsetWidth, H = cv.offsetHeight, dpr = Math.min(2, devicePixelRatio || 1);
      cv.width = W * dpr; cv.height = H * dpr; ctx.scale(dpr, dpr);
      const g = ctx.createLinearGradient(0, 0, W, H);
      ['#b8892e', '#f3d27a', '#c99a3b', '#fff1bf', '#b8892e'].forEach((c, i) => g.addColorStop(i / 4, c));
      ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
      ctx.globalAlpha = .18; ctx.fillStyle = '#fff'; ctx.font = '700 15px Inter, sans-serif';
      for (let y = 18; y < H; y += 26) for (let x = (y / 26 % 2) * 30; x < W; x += 70) ctx.fillText('STRYDE', x, y);
      ctx.globalAlpha = 1; ctx.globalCompositeOperation = 'destination-out'; ctx.lineCap = ctx.lineJoin = 'round'; ctx.lineWidth = 30;
      let ned = false, sist = null, drag = 0, klar = false, rutor = null;
      // skala fran skarm till canvas (kortet kan fortfarande vara mitt i sin intro-animation)
      const pos = e => { const b = cv.getBoundingClientRect(); return [(e.clientX - b.left) * W / b.width, (e.clientY - b.top) * H / b.height]; };
      // Manuell skrapning: folien forsvinner aldrig av sig sjalv. Vinsten raknas forst nar procenten
      // sjalv ar framskrapad (mats i sin egen ruta, inte hela kortet). Horn och kanter racker inte.
      const matRutor = () => { const c = cv.getBoundingClientRect(), k = W / c.width; return $$('.m-foil__prize b', foil).map(el => { const a = el.getBoundingClientRect(); return [(a.left - c.left) * k, (a.top - c.top) * k, a.width * k, a.height * k]; }); };
      const fri = ([x, y, w, h]) => {
        const d = ctx.getImageData(Math.max(0, x * dpr), Math.max(0, y * dpr), Math.max(1, w * dpr), Math.max(1, h * dpr)).data; let tom = 0, n = 0;
        for (let i = 3; i < d.length; i += 4 * 7) { n++; if (d[i] < 40) tom++; }
        return n ? tom / n : 0;
      };
      const smula = p => {
        if (reduce) return; const b = cv.getBoundingClientRect();
        const s = document.createElement('i'); s.className = 'm-dust';
        s.style.cssText = `left:${b.left + p[0] * b.width / W}px;top:${b.top + p[1] * b.height / H}px;--dx:${(Math.random() - .5) * 60}px;--r:${Math.random() * 360}deg`;
        document.body.appendChild(s); setTimeout(() => s.remove(), 700);
      };
      let tick = 0;
      const skrapa = e => {
        if (!ned || klar) return; const p = pos(e); foil.classList.add('is-scratching');
        ctx.beginPath(); ctx.moveTo(...(sist || p)); ctx.lineTo(...p); ctx.stroke(); sist = p;
        if (++drag % 3 === 0) smula(p);
        if (navigator.vibrate && Date.now() - tick > 90) { tick = Date.now(); navigator.vibrate(4); }
        if (drag % 8 === 0 && (rutor || (rutor = matRutor())).every(r => fri(r) > .8)) vinn();
      };
      cv.addEventListener('pointerdown', e => { ned = true; sist = pos(e); cv.setPointerCapture(e.pointerId); skrapa(e); });
      cv.addEventListener('pointermove', skrapa);
      cv.addEventListener('pointerup', () => { ned = false; sist = null; });
      function vinn() {
        klar = true; ned = false; store.set(KEY, 'skrabet:' + Date.now());
        konfetti(); if (navigator.vibrate) navigator.vibrate(60);
        visaLas();
      }
    }
    $('[data-copy]', root) && $('[data-copy]', root).addEventListener('click', e => { navigator.clipboard && navigator.clipboard.writeText(kod); e.currentTarget.textContent = tKopierad + '!'; });
  }

  /* ---------------- start ---------------- */
  // presentknappen ligger ovanfor kopbaren: barens verkliga hojd (iPhone Safari ger den hogre an 54 px)
  function atcHojd() {
    const bar = $('.sticky-atc'); if (!bar || !window.ResizeObserver) return;
    const satt = () => document.documentElement.style.setProperty('--atc-h', bar.offsetHeight + 'px');
    new ResizeObserver(satt).observe(bar); satt();
  }

  const start = () => {
    window.StrydeMotion = true;
    atcHojd();
    $$('.m-hero').forEach(hero);
    $$('.m-mech').forEach(mekanism);
    $$('[data-skrabekort]').forEach(skrapkort);
    magnetic(); ripples(); reveals(); flyToCart();   // bandet lutar inte langre vid scroll (anvandaren 2026-09-30)
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start) : start();
})();
